export default "__VITE_ASSET__db7SJqaA__"